// extracted by mini-css-extract-plugin
export default {"octaveSelector":"Octave_octaveSelector__gMGfO","octaveWrapper":"Octave_octaveWrapper__M5Hfo"};